import { WatchQueryFetchPolicy } from 'apollo-client';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';

export const useMessageQuery = (params: MessageParams, fetchPolicy?: WatchQueryFetchPolicy) => {
    const query = useQuery<MessageData, MessageParams>(MessageQuery, {
        fetchPolicy,
        variables: {
            ...params
        }
    });

    return { ...query };
};

export type MessageParams = {
    id: number;
};

export type MessageData = {
    matter: Matter;
};

export type Matter = {
    id: number;
    messages: Messages;
};

export type Messages = {
    recordCount: number;
    message: Message[];
};

export type Message = {
    date: Date;
    subject: string;
    comment: string;
    pending: boolean;
    source: number;
    title: string;
    enteredBy: string;
    enteredByUserId: string;
};

const MessageQuery = gql`
    query MessageData($id: Int!) {
        matter(id: $id) {
            id
            messages {
                recordCount
                message {
                    date
                    subject
                    comment
                    pending
                    source
                    title
                    enteredBy
                    enteredByUserId
                }
            }
        }
    }
`;
